<template>
   <section class="cycle">
      <div class="container">
         <div class="title pb-md-2 pt-2">
            <label>{{ $res("site.delivery.label") }}</label>
            <span>{{ $res("site.delivery.label") }}</span>
         </div>

         <div class="side" v-bind:class="getSide(index)" v-for="(item, index) in data" :key="index">
            <div class="col-12 col-md-6 image-wrapper" v-bind:data-aos="getAos(index)">
               <div class="image" v-bind:style="getBackground(item)"></div>
            </div>
            <div class="col-12 col-md-6 caption">
               <div>
               <h4 class="p-number">{{ item.name }}</h4>
               </div>
               <span class="mb-1" v-html="item.caption"></span>
               <span class="mb-1" v-html="item.description"></span>
               <div class="border-aniamate mt-5"></div>
            </div>
         </div>
      </div>
   </section>
</template>
<script>

export default {
   props: {
      data: {
         type: Object,
      },
      rootImagePath: {
         type: String,
      },
   },

   methods: {
      getSide(i) {
         return i % 2 == 0 ? "left " : "right";
      },

      getAos(i) {
         return i % 2 == 0 ? "fade-right" : "fade-left";
      },

      getBackground(obj) {
         return (
            "background-image : url(" + this.rootImagePath + obj.imagePath + ")"
         );
      },
   },
};
</script>

<style scoped>
.cycle,
.cycle .side {
   width: 100%;
   height: auto;
   float: left;
}

.cycle .side {
   min-height: 200px;
   height: auto;
   margin-bottom: 20px;
}

.cycle .side.right > .image-wrapper .image,
.cycle .side.right > .image-wrapper,
.cycle .side.right > .caption {
   float: right;
}

.cycle .side.left > .image-wrapper .image,
.cycle .side.left > .image-wrapper,
.cycle .side.left > .caption {
   float: left;
}

.cycle .side .caption {
   position: relative;
   padding-top: 50px;
   margin-bottom: 50px;
}

.cycle .side .image-wrapper .image {
   width: 100%;
   max-width: 270px;
   height: 270px;
   background-position: center center;
   background-size: cover;
   background-repeat: no-repeat;
   border-radius: 100%;
   border: #f8f8f8 solid 10px;
}

.caption .border-aniamate {
   width: 100%;
   height: 1px;
   background: #eaeaea;
   position: absolute;
   left: 0;
   bottom: -50px;
}

.caption h4 {
   display: inline-block;
   padding-bottom: 10px;
   background: linear-gradient(to left, white, white),
      linear-gradient(
         to left,
         rgb(28, 2, 145),
         rgb(125, 185, 235),
         rgb(212, 174, 5)
      );
   background-size: 100% 0.1em, 0 0.1em;
   background-position: 100% 100%, 0 100%;
   background-repeat: no-repeat;
   transition: background-size 400ms;
}

.caption h4:hover {
   background-size: 0 0.1em, 100% 0.1em;
}

.image {
   transition: all 0.3s ease-in-out 0s;
}

.image:hover {
   transform: scale(1.05);
}

@media screen and (max-width: 576px) {
   .cycle .side .caption {
      position: relative;
      padding-top: 20px;
      margin-bottom: 50px;
   }

   .cycle .side > .image-wrapper .image {
      float: none !important;
      margin: 0 auto;
      max-width: 200px;
      max-height: 200px;
   }
}

.title label,
.title span {
   text-align: center;
   width: 100%;
   height: 70px;
}

.title label {
   font-size: 30px;
   margin: 0;
   color: #ebc75d;
   z-index: 1;
   position: relative;
}

.title span {
   font-size: 30px;
   opacity: 0.5;
   color: #f1f1f1;
   margin-top: -60px;
   z-index: 0;
   display: block;
}
</style>
